import EventWidget from './Widget';

export default EventWidget;
